export default __webpack_public_path__ + "static/media/guichuangyiliao.df16ca89.png";